import { render, staticRenderFns } from "./DataTableTruncateField.vue?vue&type=template&id=11f2c7be"
import script from "./DataTableTruncateField.vue?vue&type=script&lang=js"
export * from "./DataTableTruncateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports